import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function updateNoteFailure(draft: Draft<IInterventionData>) {
  draft.updateNote.config.isLoading = false;
}

export default updateNoteFailure;
